// JsFromRoutes CacheKey a92237184a8d7b3ee052045cd6809e60
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/axios'

export default {
  fetchUser: definePathHelper('get', '/api/fetch_user'),
  users: definePathHelper('get', '/api/users'),
}
